// extracted by mini-css-extract-plugin
export default {"root":"Hlut8n","bg":"lJIH19","arrow":"Xb9lH4"};